import React from "react";
import InputField from "../input/inputField";
import { useGetSchoolBranchesOptions } from "../../hooks/branchHooks/branch.hooks";
import Dropdown from "../Dropdown/dropdown";
import { DropdownOptions } from "../dropdownOptions";
import { DateField } from "../input/DateField";
import { useGetClassesOptions } from "../../hooks/classHooks/class.hooks";
import { getSelectedOptionFromValue } from "../../Helper/options.helper";

interface Props {
  resultLable: string;
  setResultLabel: (resultLabel: string) => unknown;
  resultCode: string;
  setResultCode: (resultCode: string) => unknown;
  schoolBranchId: number | null;
  onBranchSelect: (branchId: number) => unknown;
  selectedClass: number | null;
  onClassSelect: (classId: number) => unknown;
  publishDate: string;
  setPublishDate: (publishDate: string) => unknown;
}

export const ResultForm = ({
  resultLable,
  setResultLabel,
  resultCode,
  setResultCode,
  schoolBranchId,
  onBranchSelect,
  selectedClass,
  onClassSelect,
  publishDate,
  setPublishDate,
}: Props) => {
  const { isLoading: isSchoolBranchOptLoading, data: SCHOOL_BRANCH_OPTIONS } =
    useGetSchoolBranchesOptions();

  const { isLoading: isClassOptionsLoading, data: CLASSES_OPTIONS } =
    useGetClassesOptions();

  if (isSchoolBranchOptLoading || isClassOptionsLoading) return <div />;

  return (
    <div className="flex flex-col">
      <InputField
        value={resultLable}
        setValue={setResultLabel}
        label="Result label"
        placeHolder="Enter result label"
      />

      <InputField
        value={resultCode}
        setValue={setResultCode}
        label="Result code"
        placeHolder="Enter result code"
      />

      <Dropdown
        label="Select school branch"
        options={SCHOOL_BRANCH_OPTIONS || []}
        selectedOption={getSelectedOptionFromValue(
          SCHOOL_BRANCH_OPTIONS || [],
          schoolBranchId
        )}
        setSelectedOption={(selectedOption: DropdownOptions) => {
          onBranchSelect(selectedOption.value as number);
        }}
      />

      <Dropdown
        label="Class"
        options={CLASSES_OPTIONS || []}
        selectedOption={getSelectedOptionFromValue(
          CLASSES_OPTIONS || [],
          selectedClass
        )}
        setSelectedOption={(option) => {
          onClassSelect(option.value as number);
        }}
      />

      <DateField
        date={publishDate}
        setDate={setPublishDate}
        label="Result publish date"
      />
    </div>
  );
};
